import { REGEXS } from "@/configs/Settings";

export function initScript(d, s, { src, id }, callBack) {
   var js,
      fjs = d.getElementsByTagName(s)[0];
   if (d.getElementById(id)) {
      if (callBack) callBack();
      return;
   }
   js = d.createElement(s);
   js.id = id;
   js.src = src;
   js.addEventListener("load", callBack);
   d.body.appendChild(js, fjs);
}

export function initMultiScript(d, s, listSrc, callBack) {
   let loadFinished = 0;
   listSrc?.forEach(({ src, id }) => {
      initScript(d, s, { src, id }, () => {
         if (loadFinished === listSrc.length - 1) {
            if (callBack) callBack();
         } else loadFinished++;
      });
   });
}

/**
 *
 * @param {*} message
 */
export function checkMessageHasUrls(message) {
   let hasUrl = false;
   var replaced = message.search(REGEXS.ANY_URL) >= 0;
   if (replaced) {
      // Remove html:
      message = message.replace(/<[^>]+>/g, "").replace(REGEXS.ANY_URL, "<a class='url-in-message' href='$1' target='_blank'>$1</a>");
      hasUrl = true;
   }

   return {
      message: message,
      hasUrl: hasUrl
   };
}

export const isInIframe = () => {
   return window.self !== window.top;
};

export function hasLs() {
   let test = "test";
   try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
   } catch (e) {
      return false;
   }
}
